import { createApiClient } from '@lms/api-client';
import { useAuthStore } from '../store/auth';
import { getNeonJwtToken } from './neon-auth';

export const apiBaseUrl = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const baseUrl = apiBaseUrl;

export const apiClient = createApiClient({
  baseUrl,
  token: localStorage.getItem('participant_token') || undefined,
  on401: () => {
    useAuthStore.getState().logout();
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login';
    }
  },
  refreshHandler: applyToken => {
    void getNeonJwtToken()
      .then(token => {
        if (!token) {
          applyToken(null);
          return;
        }
        useAuthStore.getState().setTokens(token);
        applyToken(token);
      })
      .catch(() => applyToken(null));
  },
});

// Update token when it changes in the store
export function updateApiClientToken(token: string | null) {
  apiClient.setToken(token);
}
